// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer3_footer__rrYQA","menu2":"Footer3_menu2__d7v61","link":"Footer3_link__2hMoT","icon1":"Footer3_icon1__1H1aO","icon2":"Footer3_icon2__de0Dc","me":"Footer3_me__3mruU"};